import './ImageFilters.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { RowLayout } from '../../../../../../../modules/common/layouts/rowLayout/RowLayout';
import { ImageFiltersFormContainer } from '../../containers/filters/ImageFiltersForm.container';
import { ImageNameSearchContainer } from '../../containers/filters/ImageNameSearchContainer';
import { PillsContainer } from '../../containers/filters/Pills.container';

interface IProps {
  activeFiltersCount: number;
  isModalOpen: boolean;
  onModalShow: () => void;
  onModalClose: () => void;
}

export const ImageFilters = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <>
      <RowLayout
        size='md'
        className='image-filters-controls'
      >
        <ImageNameSearchContainer />
        <Button onClick={props.onModalShow}>
          {t('filters_and_sorting')} {props.activeFiltersCount > 0 && <span>({props.activeFiltersCount})</span>}
        </Button>
        <PillsContainer />
      </RowLayout>
      <ImageFiltersFormContainer
        onAfterFilter={props.onModalClose}
        isModalOpen={props.isModalOpen}
      />
    </>
  );
});
